export default __webpack_public_path__ + "static/media/noun_Pen_3998318.10c0ccca.png";